import { useDispatch, useSelector } from "react-redux";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Reset from "./pages/Reset";
import SignUp from "./pages/SignUp";
import { Router, Route, Switch } from "react-router-dom";
import { useEffect } from "react";

import { autologin } from "./store/auth-slice";
import history from "./helpers/history-helper";

function App() {
  const authUser = useSelector((state) => state.auth.authUser);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(autologin());
  }, [dispatch]);

  return (
    <Router history={history}>
      <Switch>
        <Route path="/reset">
          <Reset />
        </Route>
        <Route path="/signup">
          <SignUp />
        </Route>
        <Route path="/">
          {authUser && <Dashboard role={authUser.role} />}
          {!authUser && <Login />}
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
